let oneday = 24 * 60 * 60 * 1000
let onehour = 60 * 60 * 1000
let oneminute = 60 * 1000

let timezone = 8;

function zfill(s, n) {
    let rs = "" + s
    let r = n - rs.length;
    for (let i = 0; i < r; i++) {
        rs = "0" + rs
    }
    return rs
}

function kjtime1(sh, sm, qishu, offset, ptime, qh_len) {
    /*
  
      sh:开始时间小时
      sm:开始时间分钟
      qishu:总期数
      offset:客户端和服务器时间偏差
      ptime:开奖间隔时间(分钟)
      qh_lenh:期数前补0长度  1分钟一起 为4，三分钟为3
	*/

    let td_str = moment().add(offset, "ms").utcOffset(8).format("YYYY-MM-DD")
    let nextday_str = moment().add(offset, "ms").add(1, "days").utcOffset(8).format("YYYY-MM-DD")
    let today_qh = moment().add(offset, "ms").utcOffset(8).format("YYYYMMDD")
    let nextday_qh = moment().add(offset, "ms").add(1, "days").utcOffset(8).format("YYYYMMDD")
        // 第一期开奖时间
    let starttime = moment(td_str).utcOffset(8).valueOf() + sh * onehour + sm * oneminute
        // 最后一起开奖时间
    let lasttime = starttime + qishu * ptime * oneminute
        //当前时间
    let currenttime = moment().add(offset, "ms").utcOffset(8).valueOf()
        // 当前时间和第一期或者最后一期时间差
    let toffset = 0

    let qh = "";

    let miao = 0;

    //console.log(moment(starttime).format())
    //console.log(moment(currenttime).format())

    if (currenttime < starttime) {
        toffset = starttime - currenttime
        qh = today_qh + zfill(1, qh_len)
        miao = toffset / 1000;

    } else if (currenttime > lasttime) {
        toffset = starttime + oneday - currenttime
        qh = nextday_qh + zfill(1, qh_len)
        miao = toffset / 1000;
    } else {
        toffset = currenttime - starttime
        miao = ptime * oneminute - toffset % (ptime * oneminute)
        miao /= 1000
            //console.log("qihao:" + toffset + "," + (ptime * oneminute) + "==" + Math.ceil(toffset / (ptime * oneminute)));
        qh = today_qh + zfill(Math.ceil(toffset / (ptime * oneminute)) + 1, qh_len)
    }


    return [qh, miao]


}


function kjtime(sh, sm, qishu, offset, ptime, qh_len) {
    /*
  
      sh:开始时间小时
      sm:开始时间分钟
      qishu:总期数
      offset:客户端和服务器时间偏差
      ptime:开奖间隔时间(分钟)
      qh_lenh:期数前补0长度  1分钟一起 为4，三分钟为3
	*/

    let td_str = moment().add(offset, "ms").utcOffset(8).format("YYYY-MM-DD") + "T00:00:00+08:00"
    let nextday_str = moment().add(offset, "ms").add(1, "days").utcOffset(8).format("YYYY-MM-DD")
    let today_qh = moment().add(offset, "ms").utcOffset(8).format("YYYYMMDD")
    let nextday_qh = moment().add(offset, "ms").add(1, "days").utcOffset(8).format("YYYYMMDD")
        // 第一期开奖时间
    let starttime = moment(td_str).utcOffset(8).valueOf() + sh * onehour + sm * oneminute
        // 最后一起开奖时间
    let lasttime = starttime + qishu * ptime * oneminute
        //当前时间
    let currenttime = moment().add(offset, "ms").utcOffset(8).valueOf()
        // 当前时间和第一期或者最后一期时间差
    let toffset = 0

    let qh = "";

    let miao = 0;

    //console.log(moment(starttime).format())
    //console.log(moment(currenttime).format())

    if (currenttime < starttime) {
        toffset = starttime - currenttime
        qh = today_qh + zfill(1, qh_len)
        miao = toffset / 1000;

    } else if (currenttime > lasttime) {
        toffset = starttime + oneday - currenttime
        qh = nextday_qh + zfill(1, qh_len)
        miao = toffset / 1000;
    } else {
        toffset = currenttime - starttime
        miao = ptime * oneminute - toffset % (ptime * oneminute)
        miao /= 1000
            //console.log("qihao:" + toffset + "," + (ptime * oneminute) + "==" + Math.ceil(toffset / (ptime * oneminute)));
        qh = today_qh + zfill(Math.ceil(toffset / (ptime * oneminute)) + 1, qh_len)
    }


    return [qh, miao]


}

function tjssc() {
    return kjtime(9, 20, 42, timeoffset, 20, 3)
}

function jsk3() {
    return kjtime(8, 50, 41, timeoffset, 20, 3)
}

function shk3() {
    return kjtime(8, 58, 41, timeoffset, 20, 3)
}

function bjpk10() {
    return kjtime(9, 30, 44, timeoffset, 20, 3)
}

function ahk3() {
    return kjtime(9, 0, 40, timeoffset, 20, 3)
}

function k3(m) {
    return kjtime(0, m, 1440 / m, timeoffset, m, 4)
}

function ssc(m) {
    return kjtime(0, m, 1440 / m, timeoffset, m, 4)
}

function debounce(fn,time){
    time = time || 200
    let timer = null;
    return function(...args) {
        var _this = this;
        if(timer){
            clearTimeout(timer);
        }
        timer = setTimeout(function(){
            timer = null;
            fn.apply(_this,args)
        },time)
    }
}

function throttle(fn,time ) {

    var self = fn
    let timer=null;
    time = time || 1000;
    return function() {

        var args = arguments;

        if(timer) {
            return
        }
         _this = this;
        timer = setTimeout(()=>{
            timer=null
        },time)
        self.apply(_this,args)
    }

}


function sec2hour(value) {

    let secondTime = parseInt(value);
    let minuteTime = 0;
    let hourTime = 0;
    if (secondTime > 60) {

        minuteTime = parseInt(secondTime / 60);

        secondTime = parseInt(secondTime % 60);

        if (minuteTime > 60) {

            hourTime = parseInt(minuteTime / 60);

            minuteTime = parseInt(minuteTime % 60);
        }
    }
    let result = "" + parseInt(secondTime) + "秒";

    if (minuteTime > 0) {
        result = "" + parseInt(minuteTime) + "分" + result;
    }
    if (hourTime > 0) {
        result = "" + parseInt(hourTime) + "小时" + result;
    }
    return result;


}

export default {
   
    jieliu(fn,time){
        return  throttle(fn,time);
    },
    s2h(value) {
        return sec2hour(value)
    },

    cp(code) {

        if (code[0] == "5") {
            return k3(5)
        } else if (code[0] == "3") {
            return k3(3)
        } else if (code == "10") {
            return k3(10)
        } else if (code == "tjssc") {
            return tjssc()
        } else if (code == "jsk3") {
            return jsk3()
        } else if (code == "shk3") {
            return shk3()
        } else if (code == "ahk3") {
            return ahk3()
        } else if (code == "bjpk10") {
            return bjpk10()
        }
    }
}


// WEBPACK FOOTER //
// ./src/kj_utils.js